import ToolChain from "./ToolChain";
import ScaleTool from "./ScaleTool";
import Editor from "./Editor";
import NewNodeTool from "./NewNodeTool";
import Tool from "./Tool";
import PanZoomTool from "./PanZoomTool";
import MoveTool from "./MoveTool";
import ConnectNodeTool from "./ConnectNodeTool";
import DeleteLayerTool from "./DeleteLayerTool";
import EditorCursorTool from "./EditorCursorTool";
import PanTool from "./PanTool";
import DuplicateNodeTool from "./DuplicateNodeTool";

export function createNewNodeToolChain(editor: Editor): Tool {
  return new ToolChain(editor, "new_node", [
    new NewNodeTool(editor),
    new ScaleTool(editor),
    new PanZoomTool(editor),
  ]);
}

export function createConnectNodeToolChain(editor: Editor): Tool {
  return new ToolChain(editor, "connect_node", [
    new EditorCursorTool(editor),
    new ConnectNodeTool(editor),
    new PanZoomTool(editor),
  ]);
}

export function createTransformToolChain(editor: Editor): Tool {
  return new ToolChain(editor, "transform", [
    new EditorCursorTool(editor),
    new ScaleTool(editor),
    new MoveTool(editor),
    new PanTool(editor),
    new PanZoomTool(editor),
    new DeleteLayerTool(editor),
  ]);
}

export function createPanToolChain(editor: Editor): Tool {
  return new ToolChain(editor, "pan_tool", [
    new EditorCursorTool(editor),
    new PanTool(editor),
    new PanZoomTool(editor),
    new DeleteLayerTool(editor),
  ]);
}
